// Adapted for Tailwind 3 from Magic UI (MIT): https://magicui.design/r/border-beam.json
import React from 'react';
import { motion, useReducedMotion } from 'motion/react';

export const BorderBeam = ({ duration = 10, delay = 0 }) => {
  const reduced = useReducedMotion();
  if (reduced) return null;
  return <div className="magic-border-beam" aria-hidden="true">
    <motion.div className="magic-border-beam-light" initial={{ offsetDistance: '0%' }}
      animate={{ offsetDistance: ['0%', '100%'] }}
      transition={{ repeat: Infinity, ease: 'linear', duration, delay }} />
  </div>;
};